/* @flow */
/* eslint-env es6,commonjs,browser */
////////////////////////////////////////////////////////////////////////////////////////////////
// Ad System JS Api                                                                           //
//                                                                                            //
// $Id: as-2.1.7.min.js.map,v 1.6 2018/04/19 06:45:46 indran Exp $                                     //
// $Source: /proj/cvs/untd_adtech/server/vas_web/js_api/dist/as-2.1.7.min.js.map,v $                         //
////////////////////////////////////////////////////////////////////////////////////////////////

/**import required es6 polyfill from babel-polyfill*/
/**To speed up flow, we are not going through core-js in node modules. Suppress below
 * import warnings
 */
// $FlowFixMe
import 'core-js/fn/array/for-each';
// $FlowFixMe
import 'core-js/fn/array/map';
// $FlowFixMe
import 'core-js/fn/array/filter';
// $FlowFixMe
import 'core-js/fn/array/reduce';
// $FlowFixMe
import 'core-js/fn/array/index-of';
// $FlowFixMe
import 'core-js/fn/array/find-index';
// $FlowFixMe
import 'core-js/fn/array/every';
// $FlowFixMe
import 'core-js/fn/array/includes';
// $FlowFixMe
import 'core-js/fn/object/keys';
// $FlowFixMe
import 'core-js/fn/object/create'; // es6 inheritance work only with this in old IE
// $FlowFixMe
import 'core-js/fn/date/now';
// $FlowFixMe
import 'core-js/es6/promise';

('#if IS_DEV'); //eslint-disable-line no-unused-expressions
// $FlowFixMe
import 'scopeleaks/scopeleaks';
('#endif'); //eslint-disable-line no-unused-expressions

import * as u from './lib/utils';
import adconfig from './lib/adconfig';
import adrotation from './lib/adrotation';
import adloader from './lib/adloader';
import adserver from './lib/adserver';
import globalParams from './lib/globalparams';
import './lib/bidincluder';

/**
 * @class
 * @description Implements AdServing API
 * @exports __as
 * @requires module:utils
 * @requires module:adconfig
 * @requires module:adrotation
 * @requires module:adloader
 * @requires module:adserver
 * @requires globalParams
 */
class asObj {
  _w: window;
  _d: Document;
  _bInited: boolean;
  _sessionLogDone: boolean;
  _sn: Object;

  constructor(w: window, d: Document) {
    this._w = w;
    this._d = d;
    this._bInited = false;
    this._sessionLogDone = false;
    ('#if IS_DEV'); //eslint-disable-line no-unused-expressions
    this._sn = window.scopeleaks.snapshot();
    ('#endif'); //eslint-disable-line no-unused-expressions
  }

  /**
   * session logging
   * @return {undefined}
   */

  _sessionLog() {
    if (this._sessionLogDone) {
      return;
    }

    const dnt = u.isDNT() ? 1 : 0;
    // prettier-ignore
    //$FlowFixMe
    const uh = u.isString(globalParams.customVars._uh5) ? globalParams.customVars._uh5 : '';
    const dApp = globalParams.isDialup ? '1' : '0';
    const dEval = u.getEvaluatedDialup(globalParams.isDialup) ? '1' : '0';
    const eType = u.getEffectiveType();

    u.logInfo(
      `sessLog:uh=${uh}&site=${
        globalParams.phInfo.site
        //$FlowFixMe
      }&dnt=${dnt}&dapp=${dApp}&dnw=${eType}&deval=${dEval}`
    );
    this._sessionLogDone = true;
  }

  /**
   * initialize API
   * @param {globalParam} [gParams] Globalparams object to initialize with
   * @returns {undefined}
   */
  init(gParams: ?globalParam) {
    if (this._bInited) {
      return;
    }
    this._bInited = true;

    // provision for lazy init, global variable __asInfo will be used if available
    gParams = gParams || this._w['__asInfo'];
    if (typeof gParams === 'undefined') {
      return;
    }

    // merge default values in globalParams with input
    u.extend(true, globalParams, gParams);

    // check for non-default global params
    if (globalParams.phInfo.site === '') {
      return;
    }

    // initialize config, loader, adserver, rotation objects
    adconfig.init(this._w, this._d, globalParams);
    adloader.init(this._w, this._d, globalParams);
    adserver.init(this._w, this._d, globalParams);
    adrotation.setGetAdsCB(this.get, this);
  }

  /**
   * load ads
   * @param {string} pageName - Page name
   * @param {Array<string>} posListArr - List of ad positions
   * @returns {undefined}
   */
  _loadAds(pageName: string, posListArr: Array<string>) {
    this._sessionLog();
    adserver.loadAds(pageName, posListArr);
  }

  /**
   * get Ads for current page
   * All the parameters are optional. In missing cases, callbacks are used to get required info
   * @param {string} [page] - Page name
   * @param {Array<string>} [posList] - List of ad positions as Array|comma-separated list
   * @param {boolean} [bCache=true] - Should cache this list?
   * @param {boolean} [bRotate=false] - For rotation?
   * @returns {undefined}
   */
  get(
    page: ?string,
    posList: ?(string | Array<string>),
    bCache: boolean,
    bRotate: boolean
  ) {
    // let us intialize, init takes care of returning if already initialized
    this.init();

    ('#if IS_DEV'); //eslint-disable-line no-unused-expressions
    //detect scope leaks now
    const l = window.scopeleaks.leaks(this._sn);
    u.logDebug(`Leaks: - ${l.toString()}`);
    //take snapshot for next run
    this._sn = window.scopeleaks.snapshot();
    ('#endif'); //eslint-disable-line no-unused-expressions

    // If bCache is true, we store the arguments passed. By default its true.
    // In eow to toggle RightAd, we should not reset posList used for rotation.
    // In this case eow needs to pass bCache as false to avoid caching.
    if (bCache !== false) {
      adconfig.setPageInfo(page, posList);
    }

    //clear adRotation and start timer
    adrotation.clear();
    if (bRotate !== true) {
      adrotation.setPageStart();
    }
    adrotation.setRotationStatus(bRotate === true);
    adloader.clearList();

    // page, posList can be configured as callback functions in global params
    // page, posList passed as arguments to _getAds are given more precedence
    let pageName = adconfig.getPageName(page),
      posListArr = adconfig.getPagePositions(posList, pageName);

    // load config before loading ads
    adconfig
      .load(globalParams.phInfo)
      .then(
        () => this._loadAds(pageName, posListArr),
        () => this._loadAds(pageName, posListArr)
      );
  }

  /**
   * populate custom variables inside iframe for old IE
   * @param {window} win - window object
   * @param {window.document} doc - document object
   * @param {string} id - Position ID
   * @returns {undefined}
   */
  populateCustomVar(win: window, doc: window.document, id: string) {
    return adloader.populateCustomVar(win, doc, id);
  }

  /**
   * render header bidding partner ads
   * @param {window} win - window object
   * @param {window.document} doc - document object
   * @param {string} pos - ad position name
   * @param {string} partner - partner name
   * @param {string} param  - Extra param
   * @returns {undefined}
   */
  renderAd(
    win: window,
    doc: window.document,
    pos: string,
    partner: string,
    param: string
  ) {
    adserver.renderBidAds(win, doc, pos, partner, param);
  }

  /**
   * utility function for ad page to get data
   * @param {window} win - window object
   * @returns {adInfo} adInfo object
   */
  getAdPageInfo(win: window /*, doc */): adInfo {
    return adloader.getIFrameAdInfo(win);
  }

  /**
   * toggle ad for ad rotation
   * @param {string} adPos - Ad position name
   * @returns {undefined}
   */
  toggleAd(adPos: string) {
    adloader.toggleAD(adPos);
  }
}

//expose our object in window scope & our module object
//export default new asObj(window, document);
let __as = new asObj(window, document);
//for webpack?
//module.exports = __as;
//Browserify needs this to populate as singleton object outside
//global.__as = __as;
//for rollup
export default __as;
